




import marked from 'marked';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import DOMPurify from 'dompurify';

const { sanitize } = DOMPurify;

export default defineComponent({
  props: {
    blok: Object as PropType<{
      content: string;
      classes: string[];
    }>,
  },
  setup(props) {
    return {
      content: computed(() => (props.blok?.content ? (marked(sanitize(props.blok.content)) as string) : '')),
    };
  },
});
